/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContactCreate = {
    properties: {
        type: {
            type: 'ContactTypeEnum',
            isRequired: true,
        },
        firstName: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        lastName: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        email: {
            type: 'string',
            isNullable: true,
            format: 'email',
        },
        homePhone: {
            type: 'string',
            isNullable: true,
        },
        workPhone: {
            type: 'string',
            isNullable: true,
        },
        cellPhone: {
            type: 'string',
            isNullable: true,
        },
        street: {
            type: 'string',
            isNullable: true,
        },
        city: {
            type: 'string',
            isNullable: true,
        },
        state: {
            type: 'string',
            isNullable: true,
            maxLength: 2,
            minLength: 2,
        },
        zip: {
            type: 'string',
            isNullable: true,
            maxLength: 10,
            minLength: 5,
        },
        zip4: {
            type: 'string',
            isNullable: true,
            maxLength: 4,
            minLength: 4,
        },
    },
};